import React from "react";
import TableRowData from "./TableRowData";
import TablePaginationActions from "./TablePaginationActions";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import { useEffect } from "react";

export default function SearchResults(props) {
	const { applications, isStandAlone, onClose } = props;

	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};
	const emptyRows =
		rowsPerPage - Math.min(rowsPerPage, applications.length - page * rowsPerPage);

	return (
		<>
			<TableContainer component={Paper}>
				<Table size="small" aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell>Application#</TableCell>
							<TableCell>Contract Number</TableCell>
							<TableCell>Referral Party ID</TableCell>
							<TableCell>Status</TableCell>
							<TableCell>Broker Name</TableCell>
							<TableCell>State</TableCell>
							<TableCell>Credit Expiration Date</TableCell>
							<TableCell>Applicant</TableCell>
							<TableCell>Account Manager</TableCell>
							<TableCell></TableCell>
							{!isStandAlone && <TableCell>Alternate Views</TableCell>}
						</TableRow>
					</TableHead>

					<TableBody>
						{applications &&
							(rowsPerPage > 0
								? applications?.slice(
										page * rowsPerPage,
										page * rowsPerPage + rowsPerPage
								  )
								: applications
							)?.map((item, i) => (
								<TableRowData
									app={item}
									isStandAlone={isStandAlone}
									key={i}
									onClose={onClose}
								/>
							))}
						{emptyRows > 0 && (
							<TableRow style={{ height: 33 * emptyRows }}>
								<TableCell colSpan={8} />
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
			{applications.length > 2 && (
				<TablePagination
					rowsPerPageOptions={[5, 10, 25, 50]}
					component={Paper}
					colSpan={3}
					count={applications.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
					ActionsComponent={TablePaginationActions}
				/>
			)}
		</>
	);
}
